export const reasonsForVisit = [
	{ type: "Ear(s)", value: "EAR_CONCERN"},
	{ type: "Eye(s)", value: "EYE_CONCERN" },
	{ type: "Upper Respiratory Tract", value: "UPPER_RESPIRATORY_TRACT_CONCERN" },
	{ type: "Lower Respiratory Tract", value: "LOWER_RESPIRATORY_TRACT_CONCERN" },
	{ type: "Skin", value: "SKIN_CONCERN" },
	{ type: "Mouth/Teeth", value: "MOUTH_TEETH_CONCERN" },
	{ type: "Gastrointestinal", value: "GASTROINTESTINAL_CONCERN" },
	{ type: "Neurologic", value: "NEUROLOGIC_CONCERN" },
	{ type: "Musculoskeletal", value: "MUSCULOSKELETAL_CONCERN" },
	{ type: "Urinary", value: "URINARY_CONCERN" },
	{ type: "Reproductive", value: "REPRODUCTIVE_CONCERN"  },
	{ type: "General Advice", value: "GENERAL_ADVICE" },
	{ type: "Emergency Triage", value: "EMERGENCY_TRIAGE" },
	{ type: "Cardiac", value: "CARDIAC_CONCERN" },
	{ type: "Nutrition", value: "NUTRITION_CONCERN" },
	{ type: "Behavior", value: "BEHAVIOR_CONCERN" },
	{ type: "Other", value: "OTHER" }
];

export const reasonForVisitAtlanta = [
	{ type: "Pre-wellness telehealth visit for EAAC", value: "PRE_WELLNESS_TELEHEALTH_VISIT_FOR_EAAC"},
]
